import { FeaturedList } from './sections';

export function DashboardContent() {
    return <FeaturedList />;
}
